import Icon from "@material-ui/icons/QuestionAnswer";
import Edit from "./QuestionEdit";
import Show from "./QuestionShow";
import Create from "./QuestionCreate";
import List from "./QuestionList";

export default {
  edit: Edit,
  create: Create,
  icon: Icon,
  list: List,
  show: Show,
};
